export default phone => {
	let reg = /\D+/g
	var res = phone.replace(reg, "" )
	if(res.length == 11){
		res = res.slice(1)
		res = res.split("")
		res.splice(0,0,"(")
		res.splice(4,0,")")
		res.splice(5,0," ")
		res.splice(9,0," ")
		res = res.join("")
	} else {
		res = res.split("")
		res.splice(-4,0,"-")
		res.splice(-8,0," ")
		res.splice(-9,0,")")
		res.splice(-13,0,"(")
		res.splice(-14,0," ")
		res = res.join("")
	}
	return res
}



// WEBPACK FOOTER //
// ./src/utils/formatPhone.js